import Vue from 'vue';
import singleSpaVue from 'single-spa-vue';
import { sync } from 'vuex-router-sync';
import AppAuthWrapper from './components/AppAuthWrapper';
import router from './router';
import store from './store';
import VueTour from 'vue-tour';
import utils from './services/utils';
import { Auth0Plugin } from '@mikmak/platform-spa-wrapper';
import { CommonLogger } from './services/logger';
import '@mdi/font/css/materialdesignicons.css';

// Important to keep these jquery imports for greater Platform
global.$ = require('jquery');
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/disable-selection';

CommonLogger.init();

Vue.use(VueTour);

Vue.use(Auth0Plugin, {
  domain: 'mikmak-dev.us.auth0.com',
  clientId: utils.isProduction()
    ? 'OLxEOVOssEopic1XITu7rJw8EXdYfztR'
    : 'pz6pN4gtKV8hWaQaDri7O9Zpu4t2hVVR',
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname,
    );
  },
});

sync(store, router);

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h) {
      return h(AppAuthWrapper);
    },
    router,
    store,
  },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
